import log from '@/services/log';

export default {
  bind(el, binding) {
    try {
      const fallbackImgFromElement = binding.value;
      // eslint-disable-next-line global-require
      const defaultFallbackImage = require('@/assets/vehicle-fallback.png');
      const img = new Image();
      const original = el.src;
      img.src = original;
      img.onload = () => {
        // eslint-disable-next-line no-param-reassign
        el.src = original;
      };
      img.onerror = () => {
        // eslint-disable-next-line no-param-reassign
        el.src = fallbackImgFromElement || defaultFallbackImage;
      };
    } catch (e) {
      log('Error in imageFallback', e);
    }
  },
};
